import 'modernizr'; // eslint-disable-line
import porta from 'porta';
import '../vendor/bootstrap';
import toaster from '../modules/toaster';

const general = () => {
  toaster.initialize();

  porta({
    messages: {
      badInput: 'Deze waarde lijkt onjuist te zijn.',
      customError: 'Deze waarde lijkt onjuist te zijn.',
      patternMismatch: 'Deze waarde lijkt onjuist te zijn.',
      rangeOverflow: 'Deze waarde mag niet groter zijn dan 10.',
      rangeUnderflow: 'Deze waarde mag niet lager zijn dan 5.',
      stepMismatch: 'Deze waarde voldoet niet aan de stappen.',
      tooLong: 'Deze waarde is te lang. Deze mag maximaal %s karakters lang zijn.',
      tooShort: 'Deze tekst is te kort. Deze moet uit minimaal %s karakters bestaan.',
      typeMismatch: 'Deze waarde lijkt onjuist te zijn.',
      valueMissing: 'Dit veld is verplicht.',
    },
    onValidate: (el) => {
      const submitButton = el.querySelector('button[type="submit"]');

      submitButton.classList.add('is-loading');
      submitButton.setAttribute('disabled', 'disabled');
    },
    onError: (el) => {
      const submitButton = el.querySelector('button[type="submit"]');

      submitButton.classList.remove('is-loading');
      submitButton.removeAttribute('disabled');
    },
  });
};

export default general;
